import React, { useState, useEffect } from 'react'
import { Formik, Form, Field, FieldArray,ErrorMessage } from 'formik';
import FormikControl from '../../../hoc/formikComponents/FormikControl'
import { useMutation, useQuery } from 'react-query'
import ToastInstance from '../../../hoc/NotificationSettings/ToastInstance'
import Fetcher from '../../../hoc/FetcherSetting/FetcherSetting'
import moment from 'moment';
import { useHistory } from "react-router-dom";
import { useParams } from 'react-router'
import * as Yup from 'yup'
import * as AiIcons from 'react-icons/ai';
import { APIURL } from '../../../hoc/AxiosSetting/axios';
import axios from 'axios';
function CorrectiveActionReport() {
    const history = useHistory();
    const [initialValues, setInitialValues] = useState(
        {
            _id: "",
            orgCode: 0,
            address: "",
            dateofaudit: "",

            effectivenessca: "",
            nonconformity: "",
            initialaudit: "Stage Two",
            teamleaderName: "",
            date: "",
            rootcause: "",
            isoStandard: "ISO 9001:2015",
            managementrepresentative: "",
            correctiveDetails: [
                {
                    clauseno: "",
                    carno: "",
                    category: "",
                    rootcause: "",
                    respondaudtee: "",
                    completecorrective: "",
                    nonconformity: "",
                    correction: "",
                    correctiveactImp: ""


                }]
        }

    )
    const onSubmit = (values, { setSubmitting, resetForm }) => {
        mutation.mutate(values)
      
    }

    
    const { orgcode } = useParams()
    // const { data: stagetwocorrective, isLoading } = useQuery(
    //     'listcorrective',
    //     () =>  { if(orgcode) return Fetcher('get', '/api/stagetwo/get/stagetwodata/' + orgcode, {})})

    // useEffect(() => {
    //     if (stagetwocorrective && initialValues.orgCode === 0) {
    //         var tempData = stagetwocorrective.data.response
    //         console.log("tempDat",tempData)
    //         tempData.dateofaudit = Date.parse(tempData.dateofaudit)
    //         tempData.initialaudit ="Stage Two";
    //         tempData.effectivenessca = stagetwocorrective.data.response.effectivenessca || "";
    //         tempData.nonconformity = stagetwocorrective.data.response.nonconformity || "";
          
    //         tempData.isoStandard= "ISO 9001:2015";
    //         tempData.date = Date.parse(tempData.date);


    //         setInitialValues(tempData)

    //     }
    // }, [orgcode && !isLoading && initialValues.orgCode === 0])

    const getUrl = () =>{
        const api= APIURL + '/api/stagetwo/get/stagetwodata/' + orgcode
        axios.get(api , { headers: {"Authorization" : 'Bearer ' + localStorage.getItem("token")} })
        .then(stagetwocorrective=>{
            if (stagetwocorrective && initialValues.orgCode === 0) {
                var tempData = stagetwocorrective.data.response
                console.log("tempDat",tempData)
                tempData.dateofaudit = Date.parse(tempData.dateofaudit)
                tempData.initialaudit ="Stage Two";
                tempData.effectivenessca = stagetwocorrective.data.response.effectivenessca || "";
                tempData.nonconformity = stagetwocorrective.data.response.nonconformity || "";
              
                tempData.isoStandard= "ISO 9001:2015";
                tempData.date = Date.parse(tempData.date);
    
    
                setInitialValues(tempData)
            }
        })
        .catch(err=>{
            var string= JSON.stringify(err).split("/")[0]
            const regex = /401/g;
            const found = string.match(regex);
            
            console.log("found",found);
            if(found !== null){
                console.log(err)
                window.location.href = "/signin"
            }

        })
    }
   
    useEffect(() => {
        if(orgcode!== undefined){
            getUrl()
        }
       
    }, [orgcode!== undefined])
    const mutation = useMutation((params) => Fetcher('patch', '/api/stagetwo/patch/stagetwocorrectiveaction', params), {
        onSuccess(data) {
            if (data.data.errorCode === 0) {
                ToastInstance('Success', ' Stage Two Audit Corrective action updated')
                window.location.href = "/"+localStorage.getItem("role")+'/view/correctiveactionreport/' + data.data.response.orgCode
                // history.push('/admin/view/correctiveactionreport/' + data.data.response.orgCode);
            } else {
                var msg = 'Subject - ' + data.data.errorMsg;
                ToastInstance('Error', msg)
            }
        },
        onError(error) {
            console.log('Got error from backend', error)
            ToastInstance('Error', 'Subject' + error)
        }
    })
    const mutationgetCompanyDetails = useMutation((params) => Fetcher('get', '/api/stagetwo/get/stagetwodata/' + params, {}), {
        onSuccess(data) {
            if (data.data.errorCode === 0) {
                var tempInitialValues = data.data.response;

                tempInitialValues.address = data.data.response.address || "";
                tempInitialValues.effectivenessca = data.data.response.effectivenessca || "";
                tempInitialValues.nonconformity = data.data.response.nonconformity || "";
                tempInitialValues.dateofaudit = Date.parse(data.data.response.dateofaudit) || null;
                tempInitialValues.date = Date.parse(data.data.response.date) || null;
                tempInitialValues.teamleaderName = data.data.response.teamleaderName || "";
                tempInitialValues.isoStandard="ISO 9001:2015";
                tempInitialValues.initialaudit ="Stage Two";
                tempInitialValues.correctiveDetails = data.data.response.correctiveDetails.length > 0 ?data.data.response.correctiveDetails: [{
                    clauseno: "",
                    carno: "",
                    category: "",
                    rootcause: "",
                    respondaudtee: "",
                    completecorrective: "",
                    nonconformity: "",
                    correction: "",
                    correctiveactImp: ""


                }]


                setInitialValues(tempInitialValues)
            } else {
                var msg = 'Company - ' + data.data.errorMsg;
                ToastInstance('Error', msg)
            }
        },
        onError(error) {
            console.log('Got error from backend', error)
            ToastInstance('Error', 'Get Company Details' + error)
        }
    })

    const effectivenessca = [
        { key: 'Satisfactory ', value: 'Satisfactory ' },
        { key: 'Needs Improvement', value: 'Needs Improvement' },
        { key: ' Unsatisfactory', value: ' Unsatisfactory' }

    ]

    const nonconformity = [
        { key: 'Cleared', value: 'Cleared' },
        { key: 'Downgraded', value: 'Downgraded' },
        { key: 'Status Quo', value: ' Status Quo' }

    ]
   
    const { data: OrgList, isLoading: companyListLoading } = useQuery(
        'listAuditPlan',
        () => Fetcher('get', '/api/clientaccess/get/listofcompaniesauditplandata/'+localStorage.getItem("userCode"), {}))
    
    
        const validationSchema = Yup.object({
            managementrepresentative: Yup.string().required('Required'),
            date                    : Yup.string().required('Required'),

                    correctiveDetails: Yup.array().of( Yup.object().shape({
                    clauseno: Yup.string().required("Clause No. Required"),
                    carno: Yup.string().required("CAR No. Required"),
                    category: Yup.string().required("Category Required"),
                    rootcause: Yup.string().required("Root Cause Required"),
                    respondaudtee: Yup.string().required(" Required"),
                    completecorrective: Yup.string().required("Required"),
                    nonconformity: Yup.string().required("Required"),
                    correction: Yup.string().required("Required"),
                    correctiveactImp: Yup.string().required("Required")

               
    
                })
              )
           
            })    
        
        
    if (companyListLoading) return <h1>Loading</h1>
    if (orgcode && initialValues.orgCode === 0){
        // window.location.href = "/signin"
          return <h1>Loading Data</h1>
         
       }
    return (
        <div>
            <Formik
                enableReinitialize={true}
                initialValues={initialValues}
               validationSchema={validationSchema}
                onSubmit={onSubmit}
            >
                {formik => <Form>
                    <div className="content-wrapper">
                        <section className="content">
                            <div className="container-fluid">
                                <div className="row">
                                    <div className="col-sm-12">
                                        <div className="card-body">
                                            <div className="row ">
                                                <div className="col-sm-12">
                                                <div className="formOuterDiv">
                                                    <div className="form1RowDiv">
                                                       
                                                            <FormikControl control='selectNACECode' label="Client Name" name='orgCode' options={OrgList.data.response} onChange={e => { mutationgetCompanyDetails.mutate(e.value); }} type="text" />
                                                       
                                                    </div>
                                                    <div className="form1RowDiv">
                                                       
                                                            <FormikControl control='input' label="Location" type="text" name='address' disabled={true} />
                                                        
                                                    </div>

                                                    <div className="form1RowDiv">
                                                        
                                                            <FormikControl control='input' label="Audit #: Initial(Stage 1/Stage 2)/Surveillance/ Recertification Audit/ Special Audit/ FollowupProcess Area:" type="text" name='initialaudit' disabled={true} />
                                                       
                                                    </div>

                                                    <div className="form2RowDiv">
                                                        
                                                            <FormikControl control='input'label='Standard' type="text" name='isoStandard' />
                                                     
                                                            <FormikControl control='input' type="text" name='teamleaderName' label="Lead Auditor" disabled={true} />
                                                        
                                                    </div>

                                                    <div className="form2RowDiv">
                                                     
                                                            <FormikControl label="Audit Date(s) "control='date' dateFormat="dd-MM-yyyy" name='dateofaudit' className="form-control" />
                                                   
                                                            <FormikControl control='input' type="text" name='managementrepresentative' label="Management Representative *" />
                                                       
                                                    </div>

                                                    <br></br>

                                                    <div className="fieldarray " >

                                                        <FieldArray name='correctiveDetails'>

                                                            {fieldArrayProps => {
                                                                const { push, remove, form } = fieldArrayProps
                                                                const { values } = form
                                                                const { correctiveDetails } = values
                                                                return (
                                                                    <div>
                                                                        {correctiveDetails.map((correctiveDetail, index) => (
                                                                            <div key={index}>
                                                                                <div className=" mt-3">
                                                                                    
                                                                                    {index > 0 && (
                                                                                      <div className="row ">
                                                                                      <div className="col-lg-11"></div>
                                                                                      <div className="col-lg-1 " >
                                                                                            <span onClick={() => remove(index)}><AiIcons.AiOutlineDelete style={{ widh: "50px", color: "red" }} /></span>
                                                                                        </div>
                                                                                        </div>
                                                                        

                                                                                    )}

                                                                                    <div className="form2RowDiv ">
                                                                                   
                                                                                          <FormikControl control='textarea' type="text" name={`correctiveDetails[${index}].nonconformity`} label="Nonconfirmity" />
                                                                                         
                                                                                         <FormikControl control='textarea' className="form-control" name={`correctiveDetails[${index}].rootcause`} label="Root Cause" />

                                                                                        
                                                                                         </div>
                                                                                         <div className="form2RowDiv mt-3">
                                                                                        
                                                                                              <FormikControl control="input" className="form-control" name={`correctiveDetails[${index}].clauseno`}  label="Clause No"/>
                                                                                     
                                                                                         <FormikControl control="input" className="form-control" name={`correctiveDetails[${index}].carno`} label="Car No"/>

                                                                                        
                                                                                         </div>
                                                                                         <div className="form2RowDiv ">
                                                                                            <div className="formSingleElement">
                                                                                                <label className="formSingleElementLabel">Category</label>
                                                                                            <Field className="form-control" name={`correctiveDetails[${index}].category`} as="select" >
                                                                                                <option value="-">Select</option>
                                                                                                <option value="Major">Major</option>
                                                                                                <option value="Minor">Minor</option>
                                                                                            </Field>
                                                                                            <div style={{color:"red",fontSize:"13px"}}>
                                                                                            <ErrorMessage name={`correctiveDetails[${index}].category`} />
                                                                                            </div>
                                                                                        </div>
                                                                                        
                                                                                            <FormikControl control="input" className="form-control" name={`correctiveDetails[${index}].respondaudtee`} label="Respond By (Auditee)" />
                                                                                        
                                                                                    </div>

                                                                                    <div className="form2RowDiv  mt-3">
                                                                                       
                                                                                            <FormikControl control="input" className="form-control" label="Complete Corrective Action " name={`correctiveDetails[${index}].completecorrective`} />
                                                                                      
                                                                                            <FormikControl control="textarea" className="form-control" label="Correction" name={`correctiveDetails[${index}].correction`} />
                                                                                        
                                                                                    </div>


                                                                                    <div className="form2RowDiv mt-3">
                                                                                        
                                                                                            <FormikControl control="textarea" className="form-control" label="Corrective Action Implemented" name={`correctiveDetails[${index}].correctiveactImp`} />
                                                                                        

                                                                                    </div>
                                                                                </div>
                                                                                <hr/>
                                                                            </div>
                                                                            
                                                                           

                                                                        ))}


                                                                        <div className="form2RowDiv mt-3">
                                                                            <div className="col-lg-11"></div>
                                                                            <div className="col-lg-1 mb-3" >
                                                                                <button type='button' className="btn btn-primary float-left mt-3" onClick={() => push('')}>Add</button>
                                                                            </div>
                                                                        </div>


                                                                    </div>

                                                                )
                                                            }}
                                                        </FieldArray>

                                                    </div>

                                                    <div className="form2RowDiv ">
                                                  
                                                            <FormikControl control='date' dateFormat="dd-MM-yyyy" name='date' label='Date *' />
                                                       
                                                    </div>

                                                    
                                                    <div className="row mt-4">
                                                        <div className="hrstyle  headingcolor" >
                                                            <h5 >IQCPL use only</h5>
                                                        </div>
                                                 </div>
                                                    <div className="row mt-3" style={{marginLeft:"0.2%"}}>
                                                        <label htmlFor="staticEmail" className="col-sm-4 mr-3">Effectiveness of CA verified:</label>
                                                        <div className="col-sm-8" >
                                                            <FormikControl control='checkboxhorizantal' name='effectivenessca' options={effectivenessca} />
                                                        </div>
                                                        <label htmlFor="staticEmail" className="col-sm-4 mt-3">Non Conformity:</label>
                                                        <div className="col-sm-8 mt-3">
                                                            <FormikControl control='checkboxhorizantal' name='nonconformity' options={nonconformity} />
                                                        </div>
                                                    </div>



                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                </div>
                            </div>
                        </section>
                    </div>
                    <div className="card-footer">
                        <div className="row">
                            <div className="col-sm-10"></div>
                            <div className="col-sm-2">
                                <button type="submit" className="btn btn-primary float-right" disabled={!formik.isValid}>Submit</button>
                            </div>

                        </div>
                    </div>
                    {/* <div className="row">
                    <div className="col-lg-11"></div>
                    <div className="col-lg-1" style={{ marginBottom: "10PX" }}>
                        <button type="submit" className="btn btn-primary">Submit</button>
                    </div>
                </div> */}
                </Form>
                }
            </Formik>
        </div>
    )
}

export default CorrectiveActionReport